<script setup>
</script>

<template>
  <div class="label label-danger text-white">
    <slot />
  </div>
</template>
